'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _parserPipe = require('./parserPipe');

var _parserPipe2 = _interopRequireDefault(_parserPipe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  withPropsOnChange 每次依 props 判斷要不要重新產生 formatter
  withhandlers 為每次 render 都重新產生 func，但只是把 props 包進 closure
  產生一個 func 與 判斷 props 是否一致，兩者不知道效率的差異
  感覺 withHandlers 好像比較好一些

  因為共用 doc state，沒做 shouldUpdate 時每個改動，所有 input 都會重 render
  */

var creator = {
  default: function _default() {
    return function defaultParser(value) {
      return value;
    };
  },
  number: function number() {
    return function numberParser(value) {
      return +value;
    };
  },
  date: function date(_ref) {
    var parseFormat = _ref.parseFormat;
    return function dateParser(value) {
      var date = (0, _moment2.default)(value, parseFormat);

      // return date could be Invalid Date, user should handle this by themself
      return date.toDate();
    };
  },
  boolean: function boolean() {
    return function booleanParser(value) {
      var asTrue = ['true', 'TRUE', '1'];
      if (asTrue.includes(value)) return true;
      var asFalse = ['false', 'FALSE', '0'];
      if (asFalse.includes(value)) return false;

      return !!value;
    };
  },
  array: function array(spec) {
    return function arrayParser(value) {
      var _spec$elementType = spec.elementType,
          elementType = _spec$elementType === undefined ? 'default' : _spec$elementType;


      var parserCreator = creator[elementType.toLowerCase()] || creator.default;
      var parser = parserCreator(spec);

      return value.split(',').map(parser);
    };
  }
};

function makeParser(spec) {
  var _spec$type = spec.type,
      type = _spec$type === undefined ? 'default' : _spec$type,
      customParser = spec.parser;

  if (customParser) return customParser;

  var parserCreator = creator[type.toLowerCase()] || creator.default;

  var typeParser = parserCreator(spec);
  return function parser(value) {
    return (0, _parserPipe2.default)(typeParser)(value);
  };
}

var specKeys = ['type', 'parser', 'parseFormat', 'elementType'];
function isEqualSpec(a, b) {
  for (var i = 0; i < specKeys.length; i++) {
    if (a[specKeys[i]] !== b[specKeys[i]]) return false;
  }
  return true;
}

makeParser.isEqualSpec = isEqualSpec;
makeParser.specKeys = specKeys;
exports.default = makeParser;


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/makeParser/index.js
// module id = 1740
// module chunks = 0